import { render, staticRenderFns } from "./SideBySideBulletPoints.vue?vue&type=template&id=2b727b62&scoped=true&"
import script from "./SideBySideBulletPoints.vue?vue&type=script&lang=js&"
export * from "./SideBySideBulletPoints.vue?vue&type=script&lang=js&"
import style0 from "./SideBySideBulletPoints.vue?vue&type=style&index=0&id=2b727b62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b727b62",
  null
  
)

export default component.exports